import { jsx as _jsx } from "react/jsx-runtime";
import { Button, makeStyles } from '@material-ui/core';
import merge from 'lodash/merge';
import { useMultiStepDrawer } from '../../../context';
const useStyles = makeStyles((theme) => ({
    primaryButton: {
        [theme.breakpoints.only('xs')]: {
            minHeight: 'auto',
            flexDirection: 'column',
            display: 'flex',
            paddingBottom: theme.spacing(0),
        },
        [theme.breakpoints.up('sm')]: {
            '& > :first-child': {
                marginLeft: theme.spacing(2),
            },
            display: 'flex',
            flexDirection: 'row-reverse',
        },
    },
    secondaryButton: {
        display: 'flex',
        alignSelf: 'center',
        [theme.breakpoints.up('sm')]: {
            flex: 1,
        },
    },
}));
/**
 * TertiaryActionButton component for the MultiStepDrawer.
 *
 * This component renders the tertiary action button for the MultiStepDrawer.
 * The tertiary action button's label and behavior can be customized via props.
 *
 * The tertiary action button can also be customized using the setTertiaryActionButton
 * method provided by the useMultiStepDrawer hook.
 *
 * @param props - The props for the TertiaryActionButton component.
 * @returns The TertiaryActionButton component.
 */
export const TertiaryActionButton = (props) => {
    const classes = useStyles();
    const { tertiaryActionProps } = useMultiStepDrawer();
    const mergedTertiaryProps = merge({}, tertiaryActionProps, props);
    if (mergedTertiaryProps.hidden) {
        return null;
    }
    return (_jsx("div", { className: classes.secondaryButton, children: _jsx(Button, { variant: 'text', color: 'primary', ...mergedTertiaryProps, children: mergedTertiaryProps.label }) }));
};
